import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import store from './store'
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';

import { StyledEngineProvider } from '@mui/material/styles';

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <StyledEngineProvider>
        <App />
      </StyledEngineProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();

// import React from "react";
// import ReactDOM from "react-dom";
// import App from "./App";
// // import "./App.scss";

// const el = document.getElementById("app");

// ReactDOM.render(<App />, el);